import { connect } from "react-redux";
import PaymentList from "./paymentList";
import { bindActionCreators } from "redux";
import { getVendorPaymentList,getVendorPaymentListSearch } from "services/redux/sales/vendorPortal/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  dataList: state.vendorPortalReducer.paymentList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getVendorPaymentList,
      getVendorPaymentListSearch,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentList);
